import { AfterViewInit, Component, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';
import { Container } from '../container';

@Component({
  selector: 'screen-group-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.less']
})
export class CardFlipComponent extends Container implements AfterViewInit, OnDestroy {
  private _initialized = false;
  private _card: HTMLElement;
  private _effect = false;
  private _autoplay = true;
  private _backfaceInvisible = true;
  private _interval = 6000;
  private _intervalHandle;

  /**
   * 是否使用effect翻转方式
   * @param param
   */
  @Input()
  set effect(param: boolean) {
    this._effect = !!param;
    this._toggleEffect();
  }

  @Input('autoplay')
  set autoplay(param: boolean) {
    this._autoplay = !!param;
    if (this._initialized) {
      this._hackAutoplay();
    }
  }

  /**
   * 设置自动翻转间隔
   * @param param
   */
  @Input()
  set interval(param: number) {
    if (Number.isInteger(param) && param > 1000 && param !== this._interval) {
      this._interval = param;
      // 当前有正在执行的定时任务，则停止当前任务 并重新执行
      if (this._initialized && this._intervalHandle) {
        this.stop();
        this.start();
      }
    }
  }

  @Input()
  set backfaceInvisible(param: boolean) {
    this._backfaceInvisible = !!param;
  }

  get backfaceInvisible() {
    return this._backfaceInvisible;
  }

  constructor(private _elementRef: ElementRef) {
    super();
  }

  @HostListener('click')
  toggle() {
    if (this._initialized) {
      this._card.classList.toggle('flipped');
    }
  }

  /**
   * 开始自动播放
   * 1、如果正在自动播放，停止当前自动播放
   * 2、开始新的自动播放
   */
  start() {
    this.stop();
    this._intervalHandle = setInterval(() => {
      this.toggle();
    }, this._interval);
  }

  /**
   * 停止自动播放
   */
  stop() {
    if (this._intervalHandle) {
      clearInterval(this._intervalHandle);
      this._intervalHandle = 0;
    }
  }

  resize() {
  }

  /**
   * 获取card dom
   * 设置effect
   * 检查是否自动播放
   */
  ngAfterViewInit() {
    this._card = this._elementRef.nativeElement.querySelector('.card');
    this._initialized = true;
    this._toggleEffect();
    this._hackAutoplay();
  }

  ngOnDestroy(): void {
    this.stop();
  }

  /**
   * 初始化后方可调用
   * @private
   */
  private _toggleEffect() {
    if (this._initialized) {
      this._card.classList.toggle('effect', this._effect);
    }
  }

  private _hackAutoplay() {
    if (this._autoplay) {
      this.start();
    }
  }
}
